<template>
  <div class="douob-video-player" :style="computedStyle" :class="{'cover-none': disableCover, 'position-fit-center': centerx, 'fit-screen': fitscreen}" v-show="showVideo">
    <video :autoplay="autoplay" ref="player" crossorigin="anonymous" :muted="muted" controlslist="noremoteplayback" >
      <source :src="src">
    </video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      player: null,
      progress: 0, // normalized
      // src: "http://192.168.0.137:3000/videos/stock-footage-hairy-monster-dancing-hip-hop-northern-soul-floor-combo-fur-bright-funny-fluffy-character-fur.mp4",
      loading: true,
      played: false,
      showVideo: false,
      shouldPlay: false,
    }
  },
  props: {
    src: {
      type: String,
      required: true,
      played: false,
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    disableCover: {
      type: Boolean,
    },
    fitscreen:{
      type: Boolean,
      default: true,
    },
    width: { type: [String, Number], required: false },
    height: { type: [String, Number], required: false },
    centerx: { type: Boolean, required: false },
    left: { type: [String, Number], required: false },
    top: { type: [String, Number], required: false },
  },
  methods: {
    pause() {
      this.player.pause()
    },
    play() {
      console.log("**** play")
      this.showVideo = true
      this.player.currentTime = 0
      this.player.play()
      this.player.muted = this.muted
    },
    stop() {
      this.showVideo = false
      this.player.pause()
    },
    handleClick() {
      if (this.showVideo && !this.played) {
        // El video deberia haber arrancado pero no habia permisos del navegador
        // Lo arranco manualmente
        this.player.play(); // anda ?
      }
    }
  },
  computed: {
    computedStyle(){
      const style = {};
      if (this.width) style.width = typeof this.width === 'number' ? `${this.width}px` : this.width;
      if (this.height) style.height = typeof this.height === 'number' ? `${this.height}px` : this.height;
      if (!this.centerx && this.left) style.left = typeof this.left === 'number' ? `${this.left}px` : this.left;
      if (this.top) style.top = typeof this.top === 'number' ? `${this.top}px` : this.top;
      
      return style;
    },
    _muted() {
      if (this.$store.state.space && this.$store.state.space.serverState < 2) {
        return true
      }
      return this.muted
    },
    volume() {
      return this.$store.getters["space/config"].space.volume / 100
    }
  },
  watch: {
    volume(val) {
      if (!this.muted) {
        this.player.volume = val
      }
    }
  },
  mounted() {
    this.player = this.$refs.player
    this.player.muted = this.muted
    this.player.addEventListener('ended', () => {
      // console.log("video ended")
      if (this.loop) {
        this.play()
      } else {
        this.showVideo = false;
        this.$emit('ended', this.progress)
      }
    });

    this.player.addEventListener('timeupdate', () => {
      this.progress = this.player.currentTime / this.player.duration
      this.$emit('progress', this.progress)
    });

    this.player.addEventListener('play', () => {
      this.played = true;
      this.showVideo = true;
      window.removeEventListener("click", this.handleClick);
    });

    window.addEventListener("click", this.handleClick);

    // const videoRequest = fetch(this.src)
    //   .then(response => response.blob());
    // videoRequest.then(blob => {
    //   console.log("Finished fetching")
    //   this.loading = false
    //   this.player.src = window.URL.createObjectURL(blob);
    // });

    if (this.autoplay) {
      this.showVideo = true
    }

    if (!this.muted) {
      this.player.volume = this.volume
    }



  },
}
</script>
<style lang="scss" scoped>
.douob-video-player {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.fit-screen {
  width: 100vw;
  height: 100vh;
}

.cover-none>video {
  object-fit: contain;
}
.position-fit-center{
  video {
    object-position: center;
  }
}
</style>